import React from 'react'
import StorageDataModelTheme from '../../../npo-start-player-web/src/storage/data-model/theme/storage-data-model-theme'
import Storage from '../../../npo-start-player-web/src/storage/storage'
import App from '../../App'
import FormBoolean from '../../components/form/boolean/FormBoolean'
import FormColor from '../../components/form/color/FormColor'
import FormButton from '../../components/form/form-button/FormButton'
import FormNumber from '../../components/form/number/FormNumber'
import FormText from '../../components/form/text/FormText'
import TabsRow from '../../components/tabs/row/TabsRow'

/**
 * The theme tab within the app.
 * 
 * @author Stan Hurks
 */
export default class AppTabTheme extends React.Component<any, StorageDataModelTheme> {

    constructor(props: any) {
        super(props)

        this.state = this.getState()
    }

    public render = () => {
        return (
            <div className="app-tab-theme">
                <TabsRow label="Primary color">
                    <FormColor
                        value={this.state.colorPrimary}
                        onChange={(colorPrimary) => {
                            this.setState({
                                colorPrimary
                            })
                        }}
                        onBlur={() => {
                            Storage.data.theme.colorPrimary.r = this.state.colorPrimary.r
                            Storage.data.theme.colorPrimary.g = this.state.colorPrimary.g
                            Storage.data.theme.colorPrimary.b = this.state.colorPrimary.b
                            this.updateTheme()
                        }} />
                </TabsRow>
                <TabsRow label="Secondary color">
                    <FormColor
                        value={this.state.colorSecondary}
                        onChange={(colorSecondary) => {
                            this.setState({
                                colorSecondary
                            })
                        }}
                        onBlur={() => {
                            Storage.data.theme.colorSecondary.r = this.state.colorSecondary.r
                            Storage.data.theme.colorSecondary.g = this.state.colorSecondary.g
                            Storage.data.theme.colorSecondary.b = this.state.colorSecondary.b
                            this.updateTheme()
                        }} />
                </TabsRow>
                <TabsRow label="Show logo?">
                    <FormBoolean
                        value={this.state.hasLogo}
                        onChange={(hasLogo) => {
                            this.setState({
                                hasLogo
                            }, () => {
                                Storage.data.theme.hasLogo = hasLogo
                                this.updateTheme()
                            })
                        }} />
                </TabsRow>
                {
                    this.state.hasLogo
                    &&
                    <>
                        <TabsRow label="Logo image">
                            <FormText
                                value={this.state.logoSrc}
                                onChange={(logoSrc) => {
                                    this.setState({
                                        logoSrc
                                    })
                                }}
                                onBlur={() => {
                                    Storage.data.theme.logoSrc = this.state.logoSrc
                                    this.updateTheme()
                                }} />
                        </TabsRow>
                        <TabsRow label="Logo link">
                            <FormText
                                value={this.state.logoURL}
                                onChange={(logoURL) => {
                                    this.setState({
                                        logoURL
                                    })
                                }}
                                onBlur={() => {
                                    Storage.data.theme.logoURL = this.state.logoURL
                                    this.updateTheme()
                                }} />
                        </TabsRow>
                        <TabsRow label="Fade out logo?">
                            <FormBoolean
                                value={this.state.logoFadeOutAtMs !== null}
                                onChange={(logoFadeOutAtMs) => {
                                    const defaultValue = new StorageDataModelTheme().logoFadeOutAtMs
                                    const value = logoFadeOutAtMs
                                        ? (
                                            this.state.logoFadeOutAtMs === null
                                                ? defaultValue
                                                : this.state.logoFadeOutAtMs
                                        )
                                        : null

                                    this.setState({
                                        logoFadeOutAtMs: value
                                    }, () => {
                                        Storage.data.theme.logoFadeOutAtMs = value
                                        this.updateTheme()
                                    })
                                }} />
                        </TabsRow>
                        {
                            this.state.logoFadeOutAtMs !== null
                            &&
                            <>
                                <TabsRow label="Fade out after how many ms?">
                                    <FormNumber
                                        value={this.state.logoFadeOutAtMs}
                                        onChange={(logoFadeOutAtMs) => {
                                            this.setState({
                                                logoFadeOutAtMs
                                            })
                                        }}
                                        onBlur={() => {
                                            Storage.data.theme.logoFadeOutAtMs = this.state.logoFadeOutAtMs
                                            this.updateTheme()
                                        }}
                                        min={0} />
                                </TabsRow>
                                <TabsRow label="Fade out duration in ms">
                                    <FormNumber
                                        value={this.state.logoFadeOutDurationMs}
                                        onChange={(logoFadeOutDurationMs) => {
                                            this.setState({
                                                logoFadeOutDurationMs
                                            })
                                        }}
                                        onBlur={() => {
                                            Storage.data.theme.logoFadeOutDurationMs = this.state.logoFadeOutDurationMs
                                            this.updateTheme()
                                        }}
                                        min={0} />
                                </TabsRow>
                            </>
                        }
                    </>
                }
                <TabsRow label="Auto hide controls">
                    <FormBoolean
                        value={this.state.autoHideControls}
                        onChange={(autoHideControls) => {
                            this.setState({
                                autoHideControls
                            }, () => {
                                Storage.data.theme.autoHideControls = autoHideControls
                                this.updateTheme()
                            })
                        }} />
                </TabsRow>
                <TabsRow label="">
                    <FormButton onClick={() => {
                        StorageDataModelTheme.reset()

                        this.setState(this.getState(), () => {
                            this.updateTheme()
                        })
                    }}>
                        Reset to default
                    </FormButton>
                </TabsRow>
            </div>
        )
    }

    /**
     * Get the state
     * 
     * @returns the state
     */
    private getState = (): StorageDataModelTheme => {
        return {
            colorPrimary: Storage.data.theme.colorPrimary,
            colorSecondary: Storage.data.theme.colorSecondary,
            hasLogo: Storage.data.theme.hasLogo,
            logoSrc: Storage.data.theme.logoSrc,
            logoURL: Storage.data.theme.logoURL,
            logoFadeOutAtMs: Storage.data.theme.logoFadeOutAtMs,
            logoFadeOutDurationMs: Storage.data.theme.logoFadeOutDurationMs,
            autoHideControls: Storage.data.theme.autoHideControls
        }
    }

    /**
     * Update the theme
     */
    private updateTheme = () => {
        App.player!.theme.update({
            colors: {
                primary: this.state.colorPrimary,
                secondary: this.state.colorSecondary
            },
            logo: this.state.hasLogo
                ? {
                    src: this.state.logoSrc,
                    url: this.state.logoURL,
                    fadeOutAtMs: this.state.logoFadeOutAtMs,
                    fadeOutDurationMs: this.state.logoFadeOutDurationMs
                }
                : null,
            autoHideControls: this.state.autoHideControls
        })
    }
}